export default __webpack_public_path__ + "static/petra-2cc7edeb3f5e3f57c0b76df7741c2ad7.jpg";